import styled from "styled-components";

export const Table = styled.table`
  margin: auto;
  tr {
    margin: 10px 0px;
    height: 55px;
  }
  th {
    text-align: right;
    padding-right: 10px;
  }
`;
